// STARSEED-CAPMARKETS-050 — single home for the public-site domain strings.
// The domain has been renamed twice (040: echosensecapitalmarkets → echosensecapital;
// 050: eqho → echo sweep); the next rename should be a one-line change here, not a
// nine-file grep-and-hope.
export const DISPLAY_DOMAIN = "www.echosensecapital.com";
export const SITE_URL = `https://${DISPLAY_DOMAIN}`;

// Email addresses moved here 2026-07-27. They were previously held on the legacy
// @eqhosensecapital.com domain (CAPMARKETS-010 hold / CAPMARKETS-021 email posture)
// because the new domain had no mailboxes. That hold is now lifted:
// echosensecapital.com is a verified secondary domain in the tryant.ai Google
// Workspace and admin@ delivers to a real group. See CAPMARKETS-021.
//
// NOTE: the Microsoft Bookings URLs in BookPage.jsx / ConsultationPage.jsx still
// carry an @eqhosensecapital.com mailbox GUID. That is live M365 tenant identity,
// NOT a display string — rewriting it breaks the booking links. Leave it alone.
export const EMAIL_DOMAIN = "echosensecapital.com";
export const SUPPORT_EMAIL = `admin@${EMAIL_DOMAIN}`;
export const COMPLIANCE_EMAIL = `compliance@${EMAIL_DOMAIN}`;
